import { render } from "./DrawDimensionPage.vue?vue&type=template&id=1ab75e5a"
import script from "./DrawDimensionPage.vue?vue&type=script&lang=js"
export * from "./DrawDimensionPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__